import { AssignedRoleDto } from '../user-management/assigned-role-model';

export class schedulerDto {
  id: number = 0;
  itemName!: string;
  description!: string;
  progress!: string;
  category!: string;
  priority!: string;
  startDate!: Date | null;
  dueDate!: Date | null;
  createdBy!: number;
  assignedTo!: string;
  notes!: string;
  attachments!: string;
  categoryList!: assesmentSchedulerDropdownDto[];
  progressList!: assesmentSchedulerDropdownDto[];
  priorityList!: assesmentSchedulerDropdownDto[];
  assignedToName!: string;
  impactAssessment!: string;
  selfAssessment!: string;
  userId!: number;
  impactArray!: impactAssessmentSchedulerHookDto[];
  selfArray!: impactAssessmentSchedulerHookDto[];
  attachmentFilterList!: any;
  attachmentArray!: any;
  trackerId!: number;
  extraColumnValue!: string;
  extraColumnValueList: extracolumnValueDto[] = [];
  createdByToName!: string;
  isExtraColumnDataExist!: boolean;
  isReminder!: boolean;
  beforeDueDate: number;
  reminderFrequency: number
  constructor() {
    this.itemName = '';
    this.description = '';
    this.progress = '';
    this.category = '';
    this.priority = '';
    this.startDate = null;
    this.dueDate = null;
    this.createdBy = 0;
    this.assignedTo = '';
    this.notes = '';
    this.attachments = '';
    this.assignedToName = '';
    this.beforeDueDate = 0;
    this.reminderFrequency = 0;
  }
}
export interface assesmentSchedulerDropdownDto {
  id: string;
  item: string;
  icon?: string;
  classStyle?: string;
}
export class filterItemDto {
  category!: string[];
  progress!: string[];
  priority!: string[];
  assignedTo!: string[];
  trackerId!: number;
  pageSize: number = 10;
  pageIndex: number = 1;
  constractor() {
    this.category = [];
    this.progress = [];
    this.priority = [];
    this.assignedTo = [];
    this.trackerId = 0;
  }
}
export interface SchedulerFilterDto {
  allData: schedulerDto[];
  filterData: schedulerDto[];
  calendarData: schedularCalendarDto[];
}
export class impactAssessmentSchedulerHookDto {
  id!: number;
  updateDbId!: number;
  impactAssessmentTemplateNo: number;
  selfAssessmentTemplateNo: number;
  ruleBookId!: string;
  title!: string;
  constructor() {
    this.id = 0;
    this.impactAssessmentTemplateNo = 0;
    this.selfAssessmentTemplateNo = 0;
    this.updateDbId = 0;
    this.ruleBookId = '';
    this.title = '';
  }
}
export class impactAssessmentData {
  impactAssessmentId: number;
  templateId: number;
  constructor() {
    this.impactAssessmentId = 0;
    this.templateId = 0;
  }
}
export class selfAssessmentData {
  selfAssessmentId: number;
  templateId: number;
  constructor() {
    this.selfAssessmentId = 0;
    this.templateId = 0;
  }
}
export interface impactSelfAssessmentSchedulerWithTemplateNoDto {
  data: impactAssessmentSchedulerHookDto[];
  templateNo: number;
}
export interface columnProjectTrackerDto {
  columnList: extraColumnDto[];
  projectTrackerList: navBarProjectManagmentDto[];
}
export interface extraColumnDto {
  colName: string;
  colId: string;
  project: string;
  type: string;
  defaultValue: string;
  option: string[];
}
export interface navBarProjectManagmentDto {
  id: number;
  parentId: number;
  screenName: string;
  screenUrl: string;
  isAllow: boolean[];
}
export interface FilterSaveDto {
  result: filterItemDto;
  categoryData: assesmentSchedulerDropdownDto[];
  progressData: assesmentSchedulerDropdownDto[];
  priorityData: assesmentSchedulerDropdownDto[];
  userData: AssignedRoleDto[];
}

export interface extracolumnValueDto {
  colName: string;
  colId: string;
  value: string;
  type: string;
  option: string[];
}
export class schedularCalendarDto {
  title: string;
  start: string;
  end: string;
  constructor() {
    this.title = '';
    this.start = '';
    this.end = '';
  }
}
export class schedularDataDto {
  month: string;
  startDate: string;
  endDate: string;
  currentDate: string;
  constructor() {
    this.month = '';
    this.startDate = '';
    this.endDate = '';
    this.currentDate = '';
  }
}
